import { render, staticRenderFns } from "./CourseReports.vue?vue&type=template&id=c6c0494c&scoped=true"
import script from "./CourseReports.vue?vue&type=script&lang=js"
export * from "./CourseReports.vue?vue&type=script&lang=js"
import style0 from "./CourseReports.vue?vue&type=style&index=0&id=c6c0494c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c0494c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c0494c')) {
      api.createRecord('c6c0494c', component.options)
    } else {
      api.reload('c6c0494c', component.options)
    }
    module.hot.accept("./CourseReports.vue?vue&type=template&id=c6c0494c&scoped=true", function () {
      api.rerender('c6c0494c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseReports.vue"
export default component.exports